import { render } from "./PhoneVisualConditionScratchesOnScreen.vue?vue&type=template&id=51737428"
import script from "./PhoneVisualConditionScratchesOnScreen.vue?vue&type=script&lang=js"
export * from "./PhoneVisualConditionScratchesOnScreen.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__